// import {done} from './scala'

const removeDuplicates = (newData, oldData) =>
    newData.filter(msg => oldData.findIndex(x => x._id === msg._id) === -1)

const updateData = (newData, oldData) =>
    newData.filter(msg => oldData.findIndex(x => x._id === msg._id) !== -1)

const defineQueue = state => {
    const totalMsgs = state.msgs.length
    if (state.limite > totalMsgs) {
        // console.log('Limite > totalMsgs')
        return state
    }
    const queueSize = state.toPlay.length
    if (queueSize === 0 || queueSize > totalMsgs || queueSize > state.limite) {
        return Array.from(Array(state.limite).keys())
    }

    const lastPlayed = state.toPlay[0]
    if (lastPlayed + 1 >= totalMsgs) {
        return Array.from(Array(state.limite).keys())
    }

    if (lastPlayed + 1 + state.limite < totalMsgs) {
        return Array.from(Array(state.limite), (_, i) => i + lastPlayed + 1)
    }

    const pSize = totalMsgs - (lastPlayed + 1)
    const pQueue = Array.from(Array(pSize), (_, i) => i + lastPlayed + 1)
    const sSize = state.limite - pSize
    const sQueue = Array.from(Array(sSize).keys())
    return [...pQueue, ...sQueue]
}

const mountToPlay = (state, newData) => {
    const toAdd = removeDuplicates(newData, state.msgs)
    const updatedData = updateData(newData, state.msgs)
    const msgs = [...updatedData, ...toAdd]

    // console.log('Mounted with:', msgs.length)

    if (msgs.length === 0) {
        return {
            ...state,
            showData: false,
            showNoData: true,
            finishedOpening: false,
            msgs,
        }
    }

    return {
        ...state,
        showData: true,
        showNoData: false,
        finishedOpening: false,
        msgs,
    }
}

const callFirst = state => {
    if (state.msgs.length === 0) {
        // console.log('Call First without data...')
        return {
            ...state,
            showData: false,
            showNoData: true,
        }
    }
    // console.log('Call First with data...')
    return {
        ...state,
        limite: state.msgs.length,
        toPlay: defineQueue(state),
        showData: true,
        showNoData: false,
        finishedOpening: true,
        // started: true
    }
}

const callNext = state => {
    const toPlay = [...state.toPlay.splice(1)]
    if (toPlay.length !== 0) {
        return {
            ...state,
            toPlay,
        }
    }

    if (state.loop) {
        return {
            ...state,
            loading: 'waitingLoad',
            showData: state.finishedOpening,
        }
    }
    return state
}

const mountReducer = (state, action) => {
    switch (action.type) {
        case 'callNext':
            return callNext(state)

        case 'finishLoading':
            return callFirst(state)

        case 'changeLoading':
            return {
                ...state,
                loading: action.payload,
            }

        case 'newData':
            return mountToPlay(state, action.payload)

        default:
            return state
    }
}

export default mountReducer
